module.exports = __webpack_public_path__ + "img/Doc13_WindsorStar18June45p3_JosephHong.835be014.jpg";